





















import { defineComponent, computed } from '@vue/composition-api';

import IncomeStats from '@/components/Report/Lite/IncomeStats.vue';
import ChartWithSelectedMonth from '@/components/Report/ChartWithSelectedMonth.vue';

import incomeRange from '@/gql/managementReport/01-Income/incomeRange.gql';

const DeliveryIncomeByDay = defineComponent({
  components: {
    IncomeStats,
    ChartWithSelectedMonth,
  },
  setup() {
    const computedPrimaryColor = computed(() => getComputedStyle(document.documentElement).getPropertyValue('--color-primary-500'));
    const computedSecondaryColor = computed(() => getComputedStyle(document.documentElement).getPropertyValue('--color-primary-300'));

    return {
      computedPrimaryColor,
      computedSecondaryColor,
      incomeRange,
    };
  },
});

export default DeliveryIncomeByDay;
